var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-primary upper-first-letter",attrs:{"disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._v(" "+_vm._s(this.content)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }